import React, { Component } from 'react';
import './pill-button-select.scss';

class PillButtonSelect extends Component {

    state = {
        selectedValues: Array.isArray(this.props.value) ? this.props.value : this.props.value ? [this.props.value] : []
    };

    componentDidMount() {
    }

    onSelect(item) {
        if (this.props.disabled) return
        if (this.props.isMultiple) {
            if (this.state.selectedValues.includes(item.value)) {
                let values = this.state.selectedValues.filter(i => i != item.value)
                this.setState({ selectedValues: values }, () => {
                    this.props.onSelect(this.state.selectedValues)
                })
            } else {
                this.setState({ selectedValues: [...this.state.selectedValues, item.value] }, () => {
                    this.props.onSelect(this.state.selectedValues)
                })
            }

        } else {
            this.setState({ selectedValues: [item.value] }, () => {
                this.props.onSelect(this.state.selectedValues[0], item)
            })
        }
    }

    render() {
        return (
            <div className={`pill-button-select`}>
                <div className={`${this.props.isHorizontalScroll ? "scroll-view" : ""}`} id="pill-scroll-1">
                    {
                        this.props.options && this.props.options.map(item => (
                            <div className={`text-center cursor-pointer d-inline-block mr-4`} onClick={() => this.onSelect(item)}>
                                <div className={`pill-button px-2 ${this.props.invalid ? 'invalid' : ''} ${this.props.size || "sm"} ${this.state.selectedValues.includes(item.value) ? "pill-button-selected" : "pill-button-not-selected"} `} style={this.props.width ? { width: this.props.width } : this.props.style ? { ...this.props.style } : {}} >
                                    {item.title}
                                </div>
                            </div>
                        ))
                    }
                </div >
            </div >
        )
    }
}

export default PillButtonSelect;